<template>
    <div>
    <masternav/>
    <!--  -->
      <b-nav class="navlinks ">
        <b-nav-item router-link :to="{ name: 'Home'}">
            <span class="navtext ">Página principal </span>
        </b-nav-item>
            <span class="mt-2 text-secondary">/</span>
        <b-nav-item router-link :to="{ name: 'Locations'}">
            <span class="navtext">Ubicaciones para alquilar autos</span>
        </b-nav-item>
            <span class="mt-2 text-secondary">/</span>
        <b-nav-item disabled>
            <span class="navtext2">{{place}}</span>
        </b-nav-item>
      </b-nav>
      <br>
    <!--  -->
    <div class="container-fluid mt-3 mb-3">
    <b-row>
      <b-col class="d-none d-sm-none d-md-block"></b-col>
      <b-col md="8">
        <div class="">
          <h1 class="titlequestion text-center text-uppercase">{{place}}</h1>
        </div>
      </b-col>
      <b-col class="d-none d-sm-none d-md-block"></b-col>
    </b-row>
    </div>
    <br>
    <!-- Reservation component -->
    <reservestep1and2/>
    <br><br><br><br>
    <!-- office details -->
    <div style="background:#ededed" class="container-fluid">
      <div class="m-4" style="border-bottom: solid 2px rgb(0, 0, 0) !important;">
        <br>
        <h2 class="titleofficedetail">Detalles de la oficina para {{place}}</h2>
        <br>
      </div>
      
      <div class="m-4">
      <b-row>
        <b-col md>
          <p class="dinregular"><b>Oficina</b> </p>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3940.848073988597!2d-79.52320168589516!3d8.986124292134958!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8faca9fd58c83d73%3A0xaa8431553e404998!2sNational%20Car%20Rental!5e0!3m2!1ses-419!2spa!4v1595926585911!5m2!1ses-419!2spa"></iframe>
          <br><br>
          <a class="textmenufindoffice">Office Address</a><br><br>
          <a class="textmenufindoffice">Office phone or call center</a><br><br>
          <b-button squared class="button" href="">INSTRUCCIONES DE CONDUCCIÓN
            <svg width="1em" height="1em" viewBox="0 2 16 18" class="bi bi-box-arrow-up-right" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M1.5 13A1.5 1.5 0 0 0 3 14.5h8a1.5 1.5 0 0 0 1.5-1.5V9a.5.5 0 0 0-1 0v4a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 0 0-1H3A1.5 1.5 0 0 0 1.5 5v8zm7-11a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.5H9a.5.5 0 0 1-.5-.5z"/>
              <path fill-rule="evenodd" d="M14.354 1.646a.5.5 0 0 1 0 .708l-8 8a.5.5 0 0 1-.708-.708l8-8a.5.5 0 0 1 .708 0z"/>
            </svg>
          </b-button>
          <br><br>
        </b-col>
        <b-col md>
          <p class="dinregular"><b>Horarios</b> </p>
          <div>
            <b-table 
            stacked 
            striped
            :items="schedule"
            small
            table-variant="light"
            ></b-table>
          </div>
          <br><br>
        </b-col>
        <b-col md>
          <p class="dinregular"><b>Servicios</b></p>
          <p class="dinregular">Lorem ipsum dolor sit amet consectetur adipisicing elit. Blanditiis sunt repellat sapiente tempore eaque ad </p>
          <p class="dinregular">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
          <br><br>
        </b-col>
      </b-row>
      <br><br><br>
      </div>
    </div>
    <!--  -->
    
    <br>
    <mainfooter/>
    </div>
</template>
<script>
import masternav          from '@/components/masternav.vue'
import maincontent        from '@/components/maincontent.vue'
import mainfooter         from '@/components/mainfooter.vue'
import rents              from '@/components/rents.vue'
import reservestep1and2   from '@/components/reservestep1and2.vue'

export default {
    name: 'Office',
    metaInfo: {
      title: "Enterprise Panama - Oficinas | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
    components:{
        masternav,
        mainfooter,
        maincontent,
        rents,
        reservestep1and2
    },
    data() {
      return {
        places: ['Aeropuerto Internacional de Tocumen, Tocumen','Calle 50, Obarrio',  'Calle Eusebio A. Morales, El Cangrejo', 'Hotel Westin, Costa del Este',  'Aeropuerto Marcos A. Gelabert, Albrook', 'Albrook Village, Albrook',  'Aeropuerto Enrique Malek, Chiriquí', 'Mareas Mall, Playa Blanca, Coclé'],
/* ejemplos */ 
        place: 'Calle 50, Obarrio',
        schedule: [
          {Domingo:   'CERRADO'},
          {Lunes:     '7:00 AM - 4:00 PM'},
          {Martes:    '7:00 AM - 4:00 PM'},
          {Miércoles: '7:00 AM - 4:00 PM'},
          {Jueves:    '7:00 AM - 4:00 PM'},
          {Viernes:   '7:00 AM - 4:00 PM'},
          {Sábado:    '7:00 AM - 3:00 PM'}
        ]
      }
    }
  }
</script>
<style  scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.dinregular{
  font-family: 'DIN 2014-Regular';
}
.dinbold{
  font-family: 'DIN 2014-ExraBold';
}
.supportside{
  background-color: rgb(235, 235, 235);
  
}
.listgroup{
  border-top: none;
  border-left: none;
  border-right: none;
}
.supporticons{
    height: 50px;
    width: 50px;
    margin-bottom: 15px;
    margin-top: 30px;
}
.titlesection{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
   
   color: #333333;
   font-weight: 600;
   margin-bottom: 15px;
}
.titlesupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
   font-weight: 600;
   margin-bottom: 15px;
}
.textsupp{
   font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #169a5a;
}
.titleofficedetail {
  color: #181918; 
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 24px;
  font-weight: 300;
}
.wrapper {
    min-height: 100%;
    height: auto !important;
    margin: 0 auto -30px;
    padding: 0 0 30px 0px;   /* new padding */
}
.collapsing {
  transition: none !important;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.questions{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: 32px;
    line-height: 40px;
    color: #169a5a;
    font-size: 17px;
    font-weight: 500;
    text-decoration: none;
    margin: 0px;
    padding: 0px;
}
.questions:hover {
  color: #006639 !important;
}
.questions:focus {
  outline: 2px solid #a4ceff !important;
}
.navlinks{
    border-bottom: solid 0.05px rgb(185, 185, 185);
    
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.button{
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  Color: #FFFFFF;
  Size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  Text-align: center;
  Text-transform: uppercase;
  Background: #169A5A;
  Height: 33px;
  border: none;
}
.button:hover{
  Background:#006639;
}
.buttonreserve{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  Color: #169A5A;
  font-size: 18px;
  font-weight: 600;
  Text-align: center;
  Background: #ffffff;
  Height: 64px;
  border: solid 2px #169A5A;
}
.buttonreserve:hover{
  Background:#169A5A;
  border: solid 2px #169A5A;
}
.buttonfindoffice{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  Color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  Text-align: center;
  Background: #169A5A;
  Height: 64px;
  border: solid 2px #169A5A;
}
.buttonfindoffice:hover{
  Background:#006639;
  border: solid 2px #006639;
}
.noline{
  text-decoration: none;
}
.titlefindoffice{
  color: #333333; 
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
  font-size: 30px;
  font-weight: 400;
  height: 35px;
  margin-top: 21px;
}
.inputfindoffice{
  border: solid 2px #bebebe;
   Height: 64px;
}
.navfontfindoffice{
color: #169A5A; 
font-family: 'DIN 2014-ExraBold', sans-serif;
font-size: 18px;
font-weight: 700;
height: 26px;
line-height: 16.3333px;
}
.navfontfindoffice:hover{
  color: #333333; 
}
.textmenufindoffice{
  font-family: 'DIN 2014-Regular', sans-serif;
  color: #169A5A;
  text-decoration: none;
  
  font-size: 16px;
}
.textmenufindoffice:hover{
  color: #333333; 
}
</style>